import { render, staticRenderFns } from "./ClientEmployees.vue?vue&type=template&id=6a89f67e&"
import script from "./ClientEmployees.vue?vue&type=script&lang=js&"
export * from "./ClientEmployees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports